// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface ITooltipSchema {
  /** Название блока, к которому относится тултип **/
  anchorBlock: EAnchorBlock;
  /** Описание тултипа **/
  description: string;
  /** Заголовок тултипа **/
  title: string;
}
export enum EAnchorBlock {
  /** Блок информации о доме **/
  'AboutHome' = 'aboutHome',
  /** Блок оценки **/
  'Estimation' = 'estimation',
  /** Блок трендов рынка **/
  'MarketTrends' = 'marketTrends',
  /** Блок истории объявлений **/
  'OffersHistory' = 'offersHistory',
}
